/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { ChallengeWrapper, ThemeWrapper } from './challenge.styled';
import ThemeImg from '&assets/images/theme.png';
import SubmitButton from '../submitButton/submitButton.component';
import { colors } from '&assets/constants/colors';
import { useNavigate } from 'react-router-dom';

interface Props {
	className?: string;
	title: string;
	description: string;
	themes: any;
	expandedIndex: number | null;
	handleAccordionChange?: any;
	index?: number;
	id: string;
}

const Challenge = (props: Props) => {
	const {
		className,
		title,
		description,
		themes,
		expandedIndex,
		handleAccordionChange,
		index,
		id,
	} = props;
	const navigate = useNavigate();
	const [expandedSubIndex, setExpandedSubIndex] = useState<number | null>(null);

	const handleSubAccordionChange = (index: number) => {
		setExpandedSubIndex((prevIndex) => (prevIndex === index ? null : index));
	};

	return (
		<ChallengeWrapper className={className ? className : ''}>
			<Accordion
				expanded={expandedIndex === index}
				onChange={() => handleAccordionChange(index)}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon fontSize="large" />}
					aria-controls="panel1a-content"
					id="panel1a-header"
				>
					<h2 className="challenge-title">{title}</h2>
				</AccordionSummary>
				<AccordionDetails>
					<p className="challenge-description">{description}</p>
					{themes.map((item: any, index: number) => {
						return (
							<ThemeWrapper key={index} index={index}>
								<Accordion
									expanded={expandedSubIndex === index}
									onChange={() => handleSubAccordionChange(index)}
								>
									<AccordionSummary
										expandIcon={<ExpandMoreIcon />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<p className="accordion-title">{item.title}</p>
									</AccordionSummary>
									<AccordionDetails>
										<div className="accordion-body">
											<div className="theme-details-text">
												<p className="accordion-content">{item.description}</p>
												{/* <SubmitButton
													title="APPLY NOW"
													className={'read-more'}
													id="read-more-btn"
													icon={true}
													iconColor={colors.white}
													titleClassName={'read-more-title'}
													handleClick={() =>
														navigate(
															`/challenge-details/${encodeURIComponent(id)}`
														)
													}
												/> */}
											</div>
										</div>
									</AccordionDetails>
								</Accordion>
							</ThemeWrapper>
						);
					})}
					<SubmitButton
						className="apply-now"
						title="View more"
						id="submit-a-challenge-landing"
						icon={true}
						handleClick={() =>
							navigate(
								`/challenge-details/${encodeURIComponent(id)}`
							)
						}
					/>
				</AccordionDetails>
			</Accordion>
		</ChallengeWrapper>
	);
};

export default Challenge;
